import { useMemo } from 'react';

import { NormalizedScheduledLeg } from '@mopla/data-models';

import { useScheduleContext } from '../contexts/ScheduleContext';

/** The break the driver is on or heading to. */
export const useBreakLeg = (): NormalizedScheduledLeg | undefined => {
	const { legs } = useScheduleContext();

	return useMemo(() => legs?.find((leg) => leg.state === 'BREAK'), [legs]);
};
